/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable complexity */
import './OfferSearchMapItem.css';

/* eslint-disable padding-line-between-statements */
import React from 'react';

import classname from '@search/classname/src';
import { errorCatcherWrap } from '@search/error/src/catcher';
import { useOfferPhoneQuery } from '@search/vtbeco-frontend-core/domain/offer/search/page/OfferPhoneQuery';
import { OfferSnippetModel, useOfferCompat } from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery';
import { useClickerTracker } from '@search/vtbeco-frontend-core/src/services/clickerTracker/useClickerTracker';
import { OfferCardMini } from '@search/vtbeco-frontend-core/view/common/components/OfferPhone/OfferCardMini';
import { OfferPhoneModal2 } from '@search/vtbeco-frontend-core/view/common/components/OfferPhone/OfferPhoneModal2';
import { Button } from '@vtblife/uikit';
import { useOfferPhoneModalOpener } from '@search/vtbeco-frontend-core/view/common/components/OfferPhone/useOfferPhoneModal';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { CALLTOUCH_ID } from '@search/classified-common/src/scripts/useCalltouch';

const cn = classname.bind(null, 'OfferSearchMapItem');

/* eslint-disable complexity */
export const OfferSearchMapItem = React.memo(errorCatcherWrap(function OfferSearchMapItem({
    model,
    forceFavoriteUpdate
}: {
    forceFavoriteUpdate?(): void;
    model: OfferSnippetModel;
}) {
    const {
        offerPhoneClickGtmId,
        isNewBuilding,
        isSellFlat
    } = useOfferCompat(model);
    const phone = useOfferPhoneQuery({
        callTouchId: model.realtyObject?.__typename === 'ProfOfferFlat' && model.realtyObject.building?.isNewbuilding ?
            CALLTOUCH_ID :
            undefined
    });
    const {
        closePhoneModal,
        openPhoneModal,
        isPhoneModalOpened
    } = useOfferPhoneModalOpener({ offerId: model.id });

    const dataLayerPush = useClassifiedOfferDataLayerPush();
    const { trackPhoneView } = useClickerTracker();
    const handlePhoneLoad = React.useCallback((e: React.MouseEvent<Element>) => {
        e.stopPropagation();
        e.preventDefault();

        dataLayerPush({ event: 'up_evt_phone', partner: model.fromCian ? 'cian' : 'unknown' });
        if (offerPhoneClickGtmId) {
            dataLayerPush({ event: offerPhoneClickGtmId, offerId: model.id });
        }

        if (phone.phoneHref) {
            openPhoneModal();
            trackPhoneView(model.id, phone.countryCode, phone.number);
            return;
        }

        phone.load({ offerId: model.id });
        openPhoneModal();
        // trackPhoneView(model.id);
    }, [ dataLayerPush, model.fromCian, model.id, offerPhoneClickGtmId, phone, openPhoneModal, trackPhoneView ]);

    return (
        <OfferCardMini placement='map' model={model} forceFavoriteUpdate={forceFavoriteUpdate}>
            <div className={cn('caller-container')} onClick={e => e.stopPropagation()}>
                <Button
                    size='m'
                    dataTest='phone-button'
                    fullWidth
                    onClick={handlePhoneLoad}
                    variant='transparent'
                >
                    Показать телефон
                </Button>
                {phone.phoneFormatted && phone.phoneHref && isPhoneModalOpened ? (
                    <OfferPhoneModal2
                        onClose={closePhoneModal}
                        isSellFlat={isSellFlat}
                        phoneFormatted={phone.phoneFormatted}
                        phoneHref={phone.phoneHref}
                        isNewBuilding={isNewBuilding}
                        isDoppelganger={phone.isDoppelganger}
                        snippet={model}
                    />
                ) : undefined}
            </div>
        </OfferCardMini>
    );
}));
